import React, { useEffect, useState } from "react";
import { collection, onSnapshot, getDocs } from "firebase/firestore";
import db from "./Firebase"; // update if your Firebase file path differs
import { format } from "date-fns";
import { Link } from "react-router-dom";

function CertificateDownload() {
    const [downloads, setDownloads] = useState([]);
    const [personalDetails, setPersonalDetails] = useState({});


    useEffect(() => {
        const fetchPersonalDetails = async () => {
            try {
                const snapshot = await getDocs(collection(db, "profile_type"));
                const userMap = {};

                snapshot.forEach((doc) => {
                    const data = doc.data();
                    userMap[data.phone_no] = {
                        name: data.name || "N/A",
                        profile_type: data.profile_type || "N/A",
                        age_range: data.age_range || "N/A",
                    };
                });

                setPersonalDetails(userMap);
            } catch (error) {
                console.error("Error fetching personal details:", error);
            }
        };

        fetchPersonalDetails();
    }, []);

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "nv_certificates_download"), (snapshot) => {
            const sorted = snapshot.docs
                .map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }))
                .sort((a, b) => b.created_date?.toDate?.() - a.created_date?.toDate?.());

            setDownloads(sorted);
        });

        return () => unsubscribe();
    }, []);



    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <h2 className="text-xl font-bold mb-4">Certificate Download Logs</h2>

                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead
                            className="thead-dark"
                            style={{ position: "sticky", top: "0" }}
                        >
                            <tr>
                                <th className="border p-2 text-left">#</th>
                                <th className="border p-2 text-left">Name</th>
                                <th className="border p-2 text-left">Phone No</th>
                                <th className="border p-2 text-left">Certificate For</th>
                                <th className="border p-2 text-left">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {downloads.map((entry, index) => (
                                <tr key={entry.id} className="hover:bg-gray-50">
                                    <td className="border p-2">{index + 1}</td>
                                    <td className="border p-2">
                                        {personalDetails[entry.phone_no]?.name || "N/A"}
                                    </td>
                                    <td className="border p-2">{entry.phone_no || "N/A"}</td>
                                    <td className="border p-2">{entry.certificate_for || "N/A"}</td>
                                    <td className="border p-2">
                                        {entry.created_date?.toDate?.()
                                            ? format(entry.created_date.toDate(), "dd/MM/yyyy, h:mm a")
                                            : "N/A"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default CertificateDownload;
